const isObeMovable = obe => {
  switch (obe?.obeStatus) {
    case 'Lost':
    case 'Terminated':
    case 'Rejected':
    case 'Cancelled':
    case undefined:
      return false;
    default:
      return true;
  }
};
export default isObeMovable;